import Canvass from './canvass'
import search from './search/search-routing'
import detail from './detail/detail-routing'

export default [{
    path: '/canvass',
    name:'canvass',
    component:Canvass,
    children:[
        ...search,
        ...detail
    ]
}]